import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//compWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Form from 'src/webapp/views/coupon/reg/Form';//입력폼
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
// import StartDatePicker from './bottomsheet/StartDatePicker';
export default function CouponRegAndUpdate() {
    /* ============================ 하위컴포넌트 데이터리셋 ============================ */
    const {state} = useLocation();
    const [clear, setClear] = useState(0);
    const onClearHandler = () => {
        setClear(clear + 1);
    }
    /* ============================ 하위컴포넌트 데이터리셋 ============================ */
    /* ==================== 하위컴포넌트 등록하기 ==================== */
    //하위컴포넌트ref
    const childRef = useRef({});
    //등록하기핸들러
    const onSubmitHandler = () => {
        childRef.current.onSubmitHandler();
    }
    /* ==================== 하위컴포넌트 등록하기 ==================== */

    const [isDisabled, setDisabled] = useState(true);
    const onValidHandler = (item, value) => {
        if (isDisabled != value) {
            setDisabled(value);
        }
    };

    return (
        <>
            <Section>
                <Menu />{/* 메뉴 */}
                <Container>
                    <FixedPanel>
                        <Titlebar title={`쿠폰 ${!state ? "등록" : "수정"}`} dept={[{ label: '기타' }, { label: '쿠폰 관리' }, { label: `쿠폰 ${!state ? "등록" : "수정"}` }]} />{/* 상단타이틀 */}
                    </FixedPanel>
                    <FlickPanel className={styles.formContainer}>
                        <Form type={1} data={null} ref={childRef} onClear={onClearHandler} onValid={onValidHandler} />

                        <Element tag={`div`} className={styles.btnArea}>
                            <Link to={-1}><FontAwesomeIcon icon="fa-light fa-chevron-left" /><Element tag={`span`}>이전으로</Element></Link>
                            <button onClick={(e) => onSubmitHandler()} disabled={isDisabled}><FontAwesomeIcon icon="fa-light fa-paper-plane-top" /><span>{!state ? "등록" : "수정"}하기</span></button>
                        </Element>
                    </FlickPanel>
                </Container>
            </Section>
        </>
    )
}